import type { ShortlistedApplicantsResponse } from '@/app/features/recruitment/job-applicants/job-applicants.type';
import CustomDrawer from '@/components/CustomDrawer';
import type { CustomModalProps } from '@/components/CustomModal';
import { useState } from 'react';
import AssignAssessment from './AssignAssessment';
import AssignInterview from './AssignInterview';

type Props = CustomModalProps & {
  id?: string;
  employees?: ShortlistedApplicantsResponse['data']['data'];
  onSuccess?: () => void;
};

type TabType = 'assessment' | 'interview';

export default function AssignModal({
  open,
  handleClose,
  employees,
  onSuccess,
}: Props) {
  const [activeTab] = useState<TabType>('assessment');

  return (
    <CustomDrawer
      width={850}
      open={open}
      onClose={handleClose}
      title={'Assign Assessment'}
    >
      {/* Toggle Buttons */}
      {/* <div className="flex bg-transparent rounded-lg p-1 w-full md:!w-[800px]">
        <button
          type="button"
          onClick={() => setActiveTab('assessment')}
          className={cn(
            'w-1/2 py-3 rounded-l-md rounded-r-none text-sm font-medium transition-all',
            activeTab === 'assessment'
              ? 'bg-white text-slate-900 shadow'
              : 'text-white bg-slate-800 hover:bg-slate-800',
          )}
        >
          Assessment
        </button>
 
        <button
          disabled
          type="button"
          onClick={() => setActiveTab('interview')}
          className={cn(
            'disabled:cursor-not-allowed disabled:opacity-60',
            'w-1/2 py-3 rounded-r-md rounded-l-none text-sm font-medium transition-all',
            activeTab === 'interview'
              ? 'bg-white text-slate-900 shadow'
              : 'text-white bg-slate-800 hover:bg-slate-800',
          )}
        >
          Interview
        </button>
      </div> */}

      {/* Content */}
      <div>
        {activeTab === 'assessment' && (
          <AssignAssessment
            handleClose={handleClose}
            employees={employees}
            onSuccess={onSuccess}
          />
        )}
        {activeTab === 'interview' && <AssignInterview />}
      </div>
    </CustomDrawer>
  );
}
